import { Navigate } from "react-router-dom";
import { Spinner, Center } from "@chakra-ui/react";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Center h="100vh"><Spinner /></Center>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
